// LOCAL TESTING ONLY
// import { createRequire } from "module";
// const require = createRequire(import.meta.url);
// const sampleAccountEvents = require("./sampleAccountEventsResponse.json");
export var adaptAccountEvents = function adaptAccountEvents(msAccountEventsFromApi) {
  var dataFromApi = msAccountEventsFromApi.loyalty.customers.events;
  var adaptedDataList = dataFromApi.reduce(function (acc, event) {
    var _event$points, _event$points2;

    // create mappedEventType prop based on if the string "purchase" is in event.eventType
    var simplifyEventType = event.eventType.includes("purchase") ? "orderItem" : event.eventType.includes("return") ? "return" : "rewardItem";
    var hideItem = simplifyEventType === "rewardItem" && !event.points && !event.coupon;
    var simplifiedApiDetail = event.coupon ? event.coupon.reward.name : event.displayDetail ? event.displayDetail : event.detail;
    var simplifiedHandoffType = event.channel === "web" || event.channel === "app" ? event.eventAttributes.deliveryType : event.channel === "pos" ? "In-Store" : "Online Retail";
    var adaptedData = {
      id: event.id,
      mappedEventType: simplifyEventType,
      orderStatus: null,
      transactionDate: event.createdAt,
      transactionTotal: event.eventAttributes.transactionTotalAmount ? parseFloat(event.eventAttributes.transactionTotalAmount).toFixed(2) : null,
      transactionTax: event.eventAttributes.taxAmount ? parseFloat(event.eventAttributes.taxAmount).toFixed(2) : null,
      transactionSubtotal: event.value ? parseFloat(event.value).toFixed(2) : null,
      transactionTip: event.eventAttributes.tipsAmount ? parseFloat(event.eventAttributes.tipsAmount).toFixed(2) : null,
      transactionGiftCardTotal: null,
      mappedOrderNumber: event.eventAttributes.onlineOrderNumber || event.eventAttributes.posReceiptId || null,
      handOffType: simplifiedHandoffType === "Dispatch" ? "Delivery" : simplifiedHandoffType,
      rewardRedeemedOnOrder: simplifyEventType === "orderItem" && dataFromApi.some(function (e) {
        return e.eventType.includes("reward") && e.eventId && e.eventId.includes(event.eventAttributes.onlineOrderNumber);
      }),
      transactionSavings: null,
      rewardsPointsRedeemed: simplifyEventType === "rewardItem" && ((_event$points = event.points) !== null && _event$points !== void 0 ? _event$points : null),
      rewardsPointsEarned: (simplifyEventType === "orderItem" || simplifyEventType === "return") && ((_event$points2 = event.points) !== null && _event$points2 !== void 0 ? _event$points2 : null),
      orderStoreLocation: event.eventAttributes.storeName,
      orderItems: null,
      apiDetail: simplifiedApiDetail,
      coupon: event.coupon
    };
    !hideItem && acc.push(adaptedData);
    return acc;
  }, []); // comment out before merge and deploy
  // console.log(adaptedDataList);

  return adaptedDataList;
}; // LOCAL TESTING ONLY
// USAGE: node.exe src/lib/ducks/accountEvents/accountEventsAdapter.js > sampleAdaptedEventsOutput.js
// adaptAccountEvents(sampleAccountEvents);
// Add "type": "module" to package.json under main